import React, { ComponentType, PropsWithChildren } from 'react';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { ImagePlaceholder } from 'common/components/image-placeholder';
import { ImageFallback } from './image-fallback';

const THUMB_SIZE = {
  thumb: {
    w: '240',
    h: '240',
  },
};

type ProductImageProps = {
  src: string | null;
  alt: string;
  Container: ComponentType<PropsWithChildren>;
};

export const ProductImage = ({ Container, src, alt }: ProductImageProps) => {
  const optimizedImage = useOptimizedImages(src, THUMB_SIZE);

  return (
    <Container>
      <ImagePlaceholder
        src={optimizedImage.thumb?.x || ''}
        alt={alt}
        title={alt}
        loading="lazy"
        fallback={<ImageFallback />}
      />
    </Container>
  );
};
